import { render, staticRenderFns } from "./reviseKFMessage.vue?vue&type=template&id=3716c9e7&scoped=true&"
import script from "./reviseKFMessage.vue?vue&type=script&lang=js&"
export * from "./reviseKFMessage.vue?vue&type=script&lang=js&"
import style0 from "./reviseKFMessage.vue?vue&type=style&index=0&id=3716c9e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3716c9e7",
  null
  
)

export default component.exports